const state = {
    page : window.APPDATA.page,
    pages : [],
    news : window.APPDATA.news,
}

const mutations = {
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_PAGE_LIST(state, pages) {
        state.pages = pages;
    },
    SET_NEWS_LIST(state, news) {
        state.news = news;
    },
}

const actions = {
    getPage({ commit, state }, params) {
        return this._vm.$http.post(this.getters.urls.api.page.get, params).then((response) => {
            if(response.data.status) {
                commit('SET_PAGE', response.data.data.page);
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },
    getPages({ commit, state }, params) {
        return this._vm.$http.post(this.getters.urls.api.page.list, params).then((response) => {
            if(response.data.status) {
                commit('SET_PAGE_LIST', response.data.data.pages);
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },
    getNews({ commit, state }, params) {
        return this._vm.$http.post(this.getters.urls.api.page.list, params).then((response) => {
            if(response.data.status) {
                commit('SET_NEWS_LIST', response.data.data.pages);
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },
}

const getters = {
    page: (state, getters) => {
        return state.page;
    },
    pages: (state, getters) => {
        return state.pages;
    },
    news: (state, getters) => {
        return state.news;
    },
}

export default {
    state,
    actions,
    mutations,
    getters,
}